/* eslint-disable camelcase */
import { useState, useEffect, useRef } from 'react';
import { hideLoader, showErrorResponseModal, showLoader } from 'store/actions/commons';
import { fileToBase64 } from 'services/commons/files';
import { downloadFileFromUrl } from 'services/commons';
import Axios from 'axios';
import { AGENT_STAFF_TOKEN, CURRENT_GIFT_TABLE } from 'constants/storage64';
import { useStorage64, useStorage64Latin } from 'hooks';
import { useStore } from 'store';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';
import _isEmpty from 'lodash/isEmpty';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import { decodeStorage } from 'functions/storageBase64';
import uploadFile from 'assets/img/upload-file.svg';
import MD5 from 'crypto-js/md5'
import styles from './styles.module.scss';


export default function Documentation() {
    
  const [storageGiftTable] = useStorage64Latin(CURRENT_GIFT_TABLE, {});
  const [giftTableInfo, dispatch] = useStore((state) => state.giftTable.giftTableInfo.data);
  const clientSSO = window.localStorage.getItem('profile_id');
  const [agentStaff] = useStorage64(AGENT_STAFF_TOKEN, '');

  const [files, setFiles] = useState([])
  const [sendCompleted, setSendCompleted] = useState(false)
  const [maxUploaded, setMaxUploaded] = useState(false)
  const [canUpload, setCanUpload] = useState(false)
  const removeFile = (filename) => {
    setFiles(files.filter(file => file.name !== filename))
  }
  const token = agentStaff || decodeStorage('access_token');
  const accessToken = `Bearer ${token}`;
  const header =  {'Authorization': accessToken}
  useEffect(() => {
    if (_isEmpty(giftTableInfo)) {
      dispatch(
        fetchGiftTableInfo({ id: storageGiftTable.id, showLoader: false })
      );
    }else{
        setCanUpload(giftTableInfo.upload_files_closing)
        loadSendedFiles()
    } 
  }, [giftTableInfo]);
  const checkHeader = (header)=>{
    let type = false;
    switch (header) {
        case '89504e47':
            type = 'image/png';
            break;
        case '47494638':
            type = 'image/gif';
            break;
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
            type = 'image/jpeg';
            break;
        case '25504446':
            type = 'application/pdf'
            break;
        default:
            type = false; // Or you can use the blob.type as fallback
            break;
    }
    return type;
  }

  useEffect(() => {
    if (files.length >= 3) {
        setMaxUploaded(true)
    }else{
        setMaxUploaded(false)
    }
  }, [files]);
  const uploadFn = async (file) => {
    file.isUploading = true;
    setFiles([...files, file])
    dispatch(showLoader());
    const fileBase64 = await fileToBase64(file);
    // upload file
    const formData = {gift_table:{file:{closing: fileBase64,name:file.name}}}
        Axios({
            url: `${BASE_PATH_API}/${ROOT}/gift-table/${storageGiftTable.id}/documents`,
            method: 'PATCH',
            data: formData,
            headers: header
          }).then((res) => {
                if (res.data && res.data.data && res.data.data.files_closing.length){
                    const files_closing = res.data.data.files_closing[0]
                    file.isUploading = false;
                    file.externalId = files_closing.id
                    file.externalUrl = files_closing.url_file.url
                    setFiles([...files, file])   
                    dispatch(hideLoader());
                }else{
                    dispatch(hideLoader());
                    dispatch(
                        showErrorResponseModal({
                          message: 'Hubo un error al cargar el archivo, por favor intente nuevamente',
                          title: 'Error',
                          callback: false
                        }))
                    removeFile(file.name)
                }
            })
            .catch((err) => {
                // inform the user
                dispatch(hideLoader());
                dispatch(
                    showErrorResponseModal({
                      message: 'Hubo un error al cargar el archivo, por favor intente nuevamente',
                      title: 'Error',
                      callback: false
                    }))
                console.error(err)
                removeFile(file.name)
            });
    }

  const uploadHandler = (event) => {
    if (event.target.files.length > 0){
        const file = event.target.files[0];
        if(!file) return;
        const blob = file; // See step 1 above
        const fileReader = new FileReader();
        fileReader.onloadend = function(e) {
            const arr = (new Uint8Array(e.target.result)).subarray(0, 4);
            let header = '';
            for(let i = 0; i < arr.length; i++) {
                header += arr[i].toString(16);
            }
            const hType = checkHeader(header)
            if (hType && hType == blob.type){
                uploadFn(file)
            }else{
                dispatch(
                    showErrorResponseModal({
                      message: 'El Archivo que intenta cargar es inválido',
                      title: 'Error',
                      callback: false
                    }))
                console.log('invalid File')
            }
        };
        fileReader.readAsArrayBuffer(blob)
    }
}
    const deleteFileHandler = (file) => {
        dispatch(showLoader());
        const deleteData = {gift_table:{files:{closing_delete:[file.externalId]}}}
            Axios({
                url: `${BASE_PATH_API}/${ROOT}/gift-table/${storageGiftTable.id}/documents`,
                method: 'PATCH',
                data: deleteData,
                headers: header
              }).then((res) => {
                    removeFile(file.name)
                    dispatch(hideLoader());
                })
                .catch((err) => {
                    // inform the user
                    dispatch(hideLoader());
                    dispatch(
                        showErrorResponseModal({
                          message: 'Hubo un error al Eliminar el archivo, por favor intente nuevamente',
                          title: 'Error',
                          callback: false
                        }))
                    console.error(err)
                });
    }
    const downloadHandler = (file) =>{
        dispatch(showLoader());
            Axios({
                url: `${BASE_PATH_API}/${ROOT}/gift-table/${storageGiftTable.id}/documents?id=${file.externalId}`,
                method: 'GET',
                headers: header
              }).then((res) => {
                    console.log(res.data.data.url)
                    downloadFileFromUrl(res.data.data.url,file.name,'blank')
                    dispatch(hideLoader());
                })
                .catch((err) => {
                    // inform the user
                    dispatch(hideLoader());
                    dispatch(
                        showErrorResponseModal({
                          message: 'Hubo un error al descargar el archivo, por favor intente nuevamente',
                          title: 'Error',
                          callback: false
                        }))
                    console.error(err)
                });
    }
    const loadSendedFiles = () =>{
        if (giftTableInfo.files_closing?.length){
            const lFiles = [];
            giftTableInfo.files_closing.forEach((file,index) => {
                if (file.active == 1){
                  setSendCompleted(true)   
                }
                lFiles.push({name:file.name,externalUrl:file.url_file.url,externalId:file.id,isUploading:false,size:'10000'})
            });
            setFiles(lFiles)   
        }else{
            // console.log('no tiene files')
        }
    }
    const sendFilesHandler = (files) => {
        dispatch(showLoader());
        if (files.length){
            const sFiles = [];
            files.forEach((file,index) => {
                 sFiles.push({id:file.externalId,active:1})
              });
            const sendData = {gift_table:{files:{closing:sFiles}}}
            Axios({
                url: `${BASE_PATH_API}/${ROOT}/gift-table/${storageGiftTable.id}/documents`,
                method: 'PATCH',
                data: sendData,
                headers: header
              }).then((res) => {
                    setSendCompleted(true)   
                    dispatch(hideLoader());
                })
                .catch((err) => {
                    // inform the user
                    dispatch(hideLoader());
                    dispatch(
                        showErrorResponseModal({
                          message: 'Hubo un error al enviar los archivos de cierre, por favor intente nuevamente',
                          title: 'Error',
                          callback: false
                        }))
                    console.error(err)
                });
        }
        //
    }
    return (
    <div className="d-flex flex-column align-items-center">
        {
            canUpload ?
            <>
            <h3 className="font-weight-bold mb-4 text-center my-4 pb-2">
                Archivos para cierre de evento y bonificación
            </h3>
        <p className='py-4'>Para poder acceder a las bonificaciones por cierre de mesa de regalos, es necesario que proporciones su <b>INE o Pasaporte vigente</b></p>
        <>
            {
            !maxUploaded && !sendCompleted ?
            <div className={styles.fileCard}>
                <div className={styles.fileInputs}>
                    <input className={styles.customFileUpload} type="file" onChange={uploadHandler} />
                    <button className={styles.customButton}>
                        <img src={uploadFile}/>
                    </button>
                    <p className={styles.main}>Suba sus documentos en formato PNG, JPEG, JPG o PDF aquí</p>
                    <p className={styles.info}>Hasta 3 archivos, max 5MB cada uno</p>
                </div>
            </div>:null
            }
        </>
        <div className={styles.fileListContainer}>
            <ul className={styles.fileList}>
                {
                    files &&
                    files.map(f => (
                        <>
                            <li
                                className={styles.fileItem}
                                key={f.externalId}>
                                <p className={styles.fileItemName}>{f.name}</p>
                                <p className={styles.fileItemSize}>{parseInt(f.size/1024)}KB</p>
                                <div className={styles.actions}>
                                    {f.isUploading && <p>Cargando Archivo...</p>
                                    }
                                    {!f.isUploading &&
                                        <p><span><a onClick={()=>downloadHandler(f)} target="blank">descargar</a></span>{ !sendCompleted && (<span onClick={() => deleteFileHandler(f)} >borrar</span>)}</p>
                                    }
                                </div>
                            </li>
                        </>
                    ))
                }
            </ul>
            { files && !sendCompleted && files.length ?<div className="text-center">
                <button className='SelectEventType__Button btn-flat btn btn-primary' type='button' onClick={() => sendFilesHandler(files)}>Enviar</button>
            </div>:null}
            
        </div>
        </>:
        <>
            <h3 className="font-weight-bold mb-4 text-center my-4 pb-2">
                Cuando sea requerido, se le solicitaran los documentos.
            </h3>
        </>}
      </div>
    );
  }
